module.exports = __webpack_public_path__ + "media/components/country-flag/static/ms-d5782f3269c20f8418a165b84d01cc8b.svg";